import React from "react";
import {string, number, shape, func, oneOfType, object} from "prop-types";
import TrackVisibility from "react-on-screen";
import withDataLayer from "./../HOCs/withDataLayer";
import Button from "../Components/Button";
import QuoteModal from "../ProductActions/QuoteModal";
import AddToCart from "../ProductActions/AddToCart";

const Item = ({
    title,
    product,
    seller,
    countries,
    pushDataLayer
}) => {
    return(
        <div className="product-sidebar">
            <TrackVisibility
                style={{
                    height: 0,
                    width: 0
                }}
                once >
                {({ isVisible }) => isVisible && onImpression({
                    name: product.name,
                    sku: product.sku,
                    seller_id: seller.id,
                    price: product.price,
                    model: product.model,
                    manufacturer_name: product.manufacturer_name,
                    pushDataLayer
                })}
            </TrackVisibility>
            <div className="product-status clearfix">
                <div className="product-info text-center">
                    {title && (
                        <h2 className="sidebar-subheading">{title}</h2>
                    )}
                    <h2 className="sidebar-subheading">
                        <a href={`/item/${product.sku}`}>{product.name_alt ? product.name_alt : product.name}</a>
                    </h2>
                    <a href={`/item/${product.sku}`}>
                        <div className="product-sidebar-img">
                            <div className="square">
                                <div className="buy-box-img-container">
                                    <img src={`${localStorage.getItem("restUrl")}/pub/media/catalog/product${product.image}`} onError={addDefaultSrc} />
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="product-messages">
                    {product.quote_status == "0" ? (
                        <AddToCart
                            sku={product.sku}
                            is_in_stock={product.is_in_stock}
                            onClick={trackOnClick.bind(null,{
                                name: product.name,
                                sku: product.sku,
                                seller_id: seller.id,
                                price: product.price,
                                model: product.model,
                                manufacturer_name: product.manufacturer_name,
                                pushDataLayer
                            })}
                        />
                    ): (
                        <QuoteModal
                            quoteProduct={{
                                sku: product.sku,
                                name: product.name,
                                image: product.image,
                                price: product.price,
                                condition: product.condition,
                            }}
                            quoteSeller={seller ? {
                                seller_logo: seller.logo,
                                seller_name: seller.name,
                                seller_locality: seller.locality,
                                seller_id: seller.id,
                            } : {}}
                            is_in_stock={product.is_in_stock}
                            defaults={{
                                message: `Hello, could I get a quote for ${product.name}?`,
                            }}
                            countries={countries}
                            onClick={trackOnClick.bind(null,{
                                name: product.name,
                                sku: product.sku,
                                seller_id: seller.id,
                                price: product.price,
                                model: product.model,
                                manufacturer_name: product.manufacturer_name,
                                pushDataLayer
                            })}
                        />
                    )}

                    <Button
                        className="btn btn-outline highlight"
                        label="View Details"
                        href={`/item/${product.sku}`}
                        onClick={trackOnClick.bind(null,{
                            name: product.name,
                            sku: product.sku,
                            seller_id: seller.id,
                            price: product.price,
                            model: product.model,
                            manufacturer_name: product.manufacturer_name,
                            pushDataLayer
                        })}
                    />
                    {product.condition && (
                        <p>Condition: {product.condition}</p>
                    )}
                    {Object.values(seller).length > 0 && (
                        <p>Sold by <a href={`/sellers/profile/${seller.id}`}> {seller.name}</a></p>
                    )}
                </div>
            </div>
        </div>
    );
};

const onImpression = ({
    name,
    sku,
    seller_id,
    model,
    manufacturer_name,
    pushDataLayer,
    price="None",
}) => {
    if (window.dataLayer){
        pushDataLayer({
            event: "Featured Product Impression",
            seller_id: seller_id,
            price: price,
            manufacturer_name: manufacturer_name,
            model: model,
            headline: name,
            adNo: sku
        });
    }
};

const trackOnClick = ({
    name,
    sku,
    seller_id,
    model,
    manufacturer_name,
    pushDataLayer,
    price="None"
}) =>{
    if (window.dataLayer){
        pushDataLayer({
            event: "Featured Product Click",
            seller_id: seller_id,
            price: price,
            manufacturer_name: manufacturer_name,
            model: model,
            headline: name,
            adNo: sku
        });
    }
};

const addDefaultSrc = (e)=>{
    e.target.src = "/images/image-not-found.png";
};

Item.defaultProps = {
    title: "",
    trackClicksAndImpressions: true
};

Item.propTypes = {
    title: string,
    countries: object,
    product: shape({
        id: oneOfType([
            number,
            string
        ]),
        name: string,
        name_alt: string,
        display_name_alt: string,
        image: string,
        sku: string,
        condition: string,
        price: number
    }),
    seller: shape({
        id: string,
        name: string,
        locality: string,
        logo: string
    }),
    pushDataLayer: func
};

export default withDataLayer(Item);
